import styled from 'styled-components';

export const Container = styled.div`
  height: inherit;
  body {
    font-family: sans-serif;
    text-align: center;
  }

  .container {
    display: flex;
    justify-content: center;
    height: 40px;
  }

  .PATIENT-loading {
    animation-duration: 0.2s;
    animation-name: ease-out-right;
    animation-fill-mode: backwards;
  }

  @keyframes ease-out-right {
    from {
      translate: 0 0;
      opacity: 0.5;
    }

    to {
      translate: -10vw 0;
      opacity: 0;
    }
  }

  .LISTING-loading {
    animation-duration: 0.3s;
    animation-name: ease-in-left;
  }

  @keyframes ease-in-left {
    from {
      translate: -5vw 0;
      opacity: 0.75;
    }

    to {
      translate: 0 0;
      opacity: 1;
    }
  }
`;
